<template>
  <v-card elevation="0" v-if="banner.active" dark color="primary">
    <div>
      <v-row class="ml-2">
        <v-card-title>
          <v-icon class="mr-2" dark>mdi-information</v-icon>
          {{ $t("components.banners.partnerBanner.informationRequired") }}
        </v-card-title>
        <v-card-text class="mr-2">
          {{
            $t(
              "components.banners.partnerBanner.pleaseFillIntheMissingInformationAboutYourBusiness"
            )
          }}
        </v-card-text>
      </v-row>
    </div>
  </v-card>
</template>
<script>
export default {
  props: {
    banner: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
